module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shopping-list/shopping-edit/shopping-edit.component.css
// module id = ./src/app/shopping-list/shopping-edit/shopping-edit.component.css
// module chunks = main